<template>
  <SectionSeparatorWrapper headerText="Change excess" headerRequiredFieldsText="Indicates required field">
    <FormField labelText="Current excess" :required="false">
      <p>{{ formatAsCurrency(currentExcess) }} payable once per {{ excessTypeText }} per financial year</p>
    </FormField>
    <FormField
      labelText="Current premium"
      :helperText="referenceData && referenceData.premiumChangeCalloutText.informationText"
      :required="false"
      v-if="currentPremiumAndFrequency.premium && currentPremiumAndFrequency.frequency"
    >
      <p>{{ formatToDisplayCurrencyPeriod(currentPremiumAndFrequency.premium, currentPremiumAndFrequency.frequency) }}</p>
    </FormField>
    <FormField v-if="!excessChangeNotAllowed" labelText="New nominated excess" :helperText="referenceData && referenceData.excessOptionsCalloutText.informationText">
      <DropdownSelect :items="excessOptions" :initialSelect="initialSelect.name" v-model="selectedExcess" />
    </FormField>
  </SectionSeparatorWrapper>
</template>

<script>
import DropdownSelect from '@general/js/components/DropdownSelect.vue';
import { FormField, SectionSeparatorWrapper } from '@/components';
import ChangeExcessMixins from '../ChangeExcessMixins';

export default {
  name: 'ChangeExcessStep',

  mixins: [ChangeExcessMixins],

  components: {
    FormField,
    DropdownSelect,
    SectionSeparatorWrapper,
  },

  props: {
    referenceData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      selectedExcess: null,
      initialSelect: {},
    };
  },

  beforeMount() {
    this.initialSelect = this.getInitialSelect();
    this.selectedExcess = this.initialSelect?.value;
  },

  watch: {
    selectedExcess(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateNewExcess(newValue);
      }
    },
  },

  methods: {
    getInitialSelect() {
      return this.excessOptions?.find((option) => {
        return option.value === this.newExcess;
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
